import { routerReducer as router } from 'react-router-redux';
import { combineReducers } from 'redux';
import type { AppPropsState } from '@atlassian/jira-servicedesk-automation-common/src/state/app-props/types';
import flags from '@atlassian/jira-servicedesk-automation-common/src/state/flags/reducer';
import persisted from './persisted/reducer';
import ui from './ui/reducer';

const appProps = (state: AppPropsState) => state || null;

export default combineReducers({ appProps, persisted, ui, router, flags });
